export default {
  title: 'Client Admin',
  tab: 'CLIENT ADMIN'
}
